let ApiUrl;
if (window.location.hostname === 'localhost' || window.location.hostname.substring(0,7) === '192.168' || window.location.hostname === '127.0.0.1') {  //前端本地测试
    ApiUrl = 'http://192.168.9.111:8100'
} else if(window.location.hostname.includes('www.yx56.net')){//外网正式
    ApiUrl = 'https://insideapi.yx56.net/cw'
}
ApiUrl = 'https://insideapi.yx56.net/cw'
export {
    ApiUrl,
};

